import { TransitTaskState } from '@zaoblako/web/modules/passage/components/transit-task/card/models/transit-task-state';

export const transitTaskInitialState: TransitTaskState = {
  loading: false,
  task: null,
  canEdit: false,
  loadingChangeStatus: false,
  panelsInfo: {
    actionsShow: true,
    residenceShow: true
  },
  filesInfo: {
    files: [],
    loading: false
  },
  historyInfo: {
    items: [],
    queryParams: {
      limit: 100,
      offset: 0
    },
    paginationLoading: false,
    loading: true,
    count: 0
  },
  userGroups: [],
  clients: []
};
